import React from "react";
import { Mail, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-neutral-300">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-10 py-10">
        <div className="grid gap-10 sm:gap-12 lg:gap-14 lg:grid-cols-5">
          {/* Brand + socials */}
          <div className="lg:col-span-2 text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
              <img src="/assets/payme-sol-logo.png" alt="Payme.sol" className="h-9 w-auto md:h-8 lg:h-10" />
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed max-w-md mx-auto lg:mx-0">
              Seamless POS for Solana payments. Generate QR codes, scan & pay, and get near‑instant confirmations.
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-3 sm:gap-4">
              <a href="https://github.com/paymesol/basic" target="_blank" rel="noreferrer noopener" className="w-10 h-10 rounded-lg border border-neutral-800 bg-neutral-900/40 text-neutral-300 hover:text-indigo-400 hover:border-indigo-500/50 hover:bg-neutral-800/70 inline-flex items-center justify-center transition-colors">
                <Github className="size-5" />
              </a>
              <a href="mailto:info@paymesol.app" target="_blank" rel="noreferrer noopener" className="w-10 h-10 rounded-lg border border-neutral-800 bg-neutral-900/40 text-neutral-300 hover:text-indigo-400 hover:border-indigo-500/50 hover:bg-neutral-800/70 inline-flex items-center justify-center transition-colors" aria-label="Email">
                <Mail className="size-5" />
              </a>
            </div>
          </div>

          {/* Link sections */}
          <div className="lg:col-span-3 grid grid-cols-1 gap-8 sm:gap-10 md:gap-12 text-center place-items-center">
            <div>
              <h4 className="mb-3 text-sm font-semibold text-white">Resources</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="/docs/" className="hover:text-indigo-400">Docs</a></li>
                <li><a href="/docs/frequently-asked-questions/" className="hover:text-indigo-400">FAQ</a></li>
                <li><a href="/docs/support/" className="hover:text-indigo-400">Support</a></li>
                <li><a href="/docs/media-kit/" className="hover:text-indigo-400">Media kit</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-neutral-900/60">
        <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-10 py-6">
          <p className="text-[11px] sm:text-xs text-neutral-500 leading-relaxed text-center">
            Payme.sol does not collect personal data. Use at your own risk. No financial or legal advice is provided. Conduct your own research (DYOR) and comply with local laws. Payme.sol assumes no liability.
          </p>
        </div>
      </div>

      <div className="border-t border-neutral-900/60">
        <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-10 py-4 text-xs text-neutral-500">
          <div className="flex flex-col items-center gap-3">
            <span className="text-center">© 2024 - {new Date().getFullYear()} Payme.sol.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
